/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { DayCalendarSkeleton, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar, PickersDayProps } from '@mui/x-date-pickers';
import 'dayjs/locale/pt-br';
import dayjs, { Dayjs } from 'dayjs';
import Badge from '@mui/material/Badge';

export interface FormatedDate {
  date?: string; 
  datas?: string;
  uuid?: string;
  frequencia: string;
  descricao: string;
  tempo?: string;
  nome: string;
}

const padZero = (num: number): string => num < 10 ? `0${num}` : `${num}`;

function ServerDay(props: PickersDayProps<Dayjs> & { highlightedDates?: Dayjs[] }) {
  const { highlightedDates = [], day, outsideCurrentMonth, ...other } = props;

  const isSelected =
    !outsideCurrentMonth && highlightedDates.some((highlightedDay) => dayjs(day).isSame(highlightedDay, 'day'));

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      badgeContent={isSelected ? '🎫' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}

type VCalendarProps = {
  values: FormatedDate[];
}

export function VCalendar({ values }: VCalendarProps) {
  const [highlightedDates, setHighlightedDates] = useState<Dayjs[]>([]);

  useEffect(() => {
    const datesToHighlight: Dayjs[] = [];

    values.forEach(item => {

      const dateValue = item.date || item.datas || (item as any).dias;

      if (dateValue && item.frequencia) {
        if (item.frequencia === 'unica') {
          const parsedDate = dayjs(dateValue, 'DD/MM/YYYY');
          if (parsedDate.isValid()) {
            datesToHighlight.push(parsedDate);
          }
        } else if (item.frequencia === 'semanal') {
          const dateStrings = dateValue.split(',').map((s: string) => s.trim());

          dateStrings.forEach((dateStr: string) => {
            const parsedDate = dayjs(dateStr, 'DD/MM/YYYY');
            if (parsedDate.isValid()) {
              datesToHighlight.push(parsedDate);
            }
          });
        } else if (item.frequencia === 'mensal') {
          const dateStrings = dateValue.split(',').map((s: string) => s.trim());

          dateStrings.forEach((dateStr: string) => {
            const parts = dateStr.split('/');
            if (parts.length === 3) {
              const day = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10);
              const year = parseInt(parts[2], 10);

              const formattedDateStr = `${padZero(day)}/${padZero(month)}/${year}`;

              const parsedDate = dayjs(formattedDateStr, 'DD/MM/YYYY');
              if (parsedDate.isValid()) {
                datesToHighlight.push(parsedDate);
              }
            }
          });
        }else if(item.frequencia === 'quinzenal') {
          const dateStrings = dateValue.split(',').map((s: string) => s.trim());

          dateStrings.forEach((dateStr: string) => {
            const parsedDate = dayjs(dateStr, 'DD/MM/YYYY');
            if (parsedDate.isValid()) {
              datesToHighlight.push(parsedDate);
              datesToHighlight.push(parsedDate.add(15, 'day'));
            }
          });
        }
      }
    });

    setHighlightedDates(datesToHighlight);
  }, [values]);

  dayjs.locale('pt-br');

  const dayOfWeekFormatter = (date: Dayjs) => {
    const daysOfWeek = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
    return daysOfWeek[date.day()];
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DateCalendar
        renderLoading={() => <DayCalendarSkeleton />}
        slots={{
          day: ServerDay,
        }}
        slotProps={{
          day: {
            highlightedDates,
          } as any,
        }}
        dayOfWeekFormatter={dayOfWeekFormatter}
      />
    </LocalizationProvider>
  );
}